// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"b9e81520","264":"50614944","396":"6361e28b","979":"ac4181ee"}[chunkId] + ".chunk.js";
};